import store from "../../../../../store";
import Cabinet from "../../parts/cabinet";
import {LayoutAbbreviations} from "../../constants";
import CountertopCommon from "../countertopCommon";

export default class Countertop extends CountertopCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'countertop';
    this.partName = 'Countertop';
    this.translateId = "visualizer.kitchen.countertop.countertop";
    this.isStoneFeature = true;
    this.toggleSwitchedOffByUser = false;  // is used for returning toggle back when feature is found
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      if (partNumber === 3) {
        dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("N"))) || [];
      }
      return super.load_(dbFeature, new Countertop(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    } else {
      return super.load_(dbFeature, new Countertop());
    }
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked, clickFrom);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.countertop.activeFeature = this;
    }
    this.featureClicked();
  }

  availableFeatures(cabinetFeatures) {
    return cabinetFeatures.filter(cabinetFeature => cabinetFeature.partNumber === 1)
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const bottomCabinet = cabinetParent && cabinetParent.bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      this.activeFeatureParts = this.setActiveFeatureParts();
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CountertopGroup.Countertop;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
      if (this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if(activeFeaturePart && activeFeaturePart.layer && activeFeaturePart.dbFeature.metaData["Part"]) {
            const partNumber = +activeFeaturePart.dbFeature.metaData["Part"][0];
            activeFeaturePart.layer.zIndex = zIndexes.CountertopGroup["Countertop"+partNumber];
          }
        })
      }
    }
  }

  setActiveFeatureParts(fromFeature = this.activeFeature) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getCountertopGroupsSplittedFeatureName();
      const conditions = this.getArrayOfConditions();
      activeFeatureParts = this.featuresParts.filter((feature) => {
        const name2 = feature.getCountertopGroupsSplittedFeatureName();
        return (name1 === name2) && feature.matchesMetaForArrayOfConditions(conditions);
      });
      const filterGroups = store.getState().filterState.filterGroups;
      const edgeFilterGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
      const fromFeatureFilters = fromFeature.dbFeature.filterValueIDs;
      if (edgeFilterGroup && fromFeatureFilters && fromFeatureFilters[edgeFilterGroup.id]) {
        const edgeFilterGroupId = edgeFilterGroup.id;
        const realActiveFeaturePart = activeFeatureParts.find(activeFeaturePart => {
          return this.featureIsMatchingEdgeFilters(activeFeaturePart, fromFeatureFilters[edgeFilterGroupId], edgeFilterGroupId)
        });
        activeFeatureParts = realActiveFeaturePart ? [realActiveFeaturePart] : []
      }
    }
    activeFeatureParts.forEach((activeFeaturePart) => {
      if(activeFeaturePart) {
        activeFeaturePart.disabled = this.disabled
      }
    });
    return activeFeatureParts
  }

  featureIsMatchingEdgeFilters(currentCheckFeature, activeEdgeFilter, edgeFilterGroupId) {
    const currentFeatureEdgeFilters = currentCheckFeature && currentCheckFeature.dbFeature
      && currentCheckFeature.dbFeature.filterValueIDs
      && currentCheckFeature.dbFeature.filterValueIDs[edgeFilterGroupId];
    return currentFeatureEdgeFilters && currentFeatureEdgeFilters.some(filterValueId => filterValueId === activeEdgeFilter[0]);
  }

  canUseNavigationFilterSteps() {
    const parent = this.getParent();
    return parent.edge // display filters only if edges exist
  }

  canUseNavigationFilter() {
    return true //TODO[Artem] add here features filters check
  }

}
